const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'baggage_segment',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),
    modelClass: require('./model'),
    methods: {
        autoSelect(data) {
            this.autoSelect(data);
        },
        changeSelection(newOptionID) {
            this.changeSelection(newOptionID);
        },
        onBaggageRemove(evt) {
            this.onBaggageRemove(evt);
        },
    },
});
